<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      class="elevation-1"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.cases_id ? props.item.cases_id : '-' }}</td>
        <td>{{ props.item.item_type_name }}</td>
        <td>{{ props.item.service.description }}</td>
        <!-- <td>{{ props.item.item_type_name }}</td> -->
        <!-- <td>{{ itemTypeStringify(props.item.item_type) }}</td> -->
        <td>{{ props.item.schedule_start }}</td>
        <td>{{ props.item.schedule_end }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          <confirmation-dialog ref="confirm"></confirmation-dialog>
        </td>
      </template>
    </v-data-table>
    <AppEditBookingsDialog/>
    <AddBookingButton/>
  </div>
</template>

<script>
  import AddBookingButton from '@/components/buttons/AddBookingButton'
  import AppEditBookingsDialog from '@/components/dialogs/AppEditBookingsDialog'
  import resourcesMixins from '@/mixins/Resources'
  import crudAPI from '@/api/resources/crud'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'

  export default {
    name: 'Bookings',
    components: { AddBookingButton, AppEditBookingsDialog, ConfirmationDialog },
    mixins: [ resourcesMixins, itemTypesMixins ],
    data () {
      return {
        resources: 'schedules',
        items: [],
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Case ID', value: 'cases_id' },
          { text: 'Name', value: 'item_id' },
          { text: 'Role', value: 'service.description' },
          { text: 'From', value: 'schedule_start' },
          { text: 'To', value: 'schedule_end' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Updated at', value: 'updated_at' },
          { text: 'Actions', value: 'actions' }
        ]
      }
    },
    methods: {
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      },
      loadListingSuccess (result) {
        this.items = []

        result.forEach((item, i) => {
          let res = this.itemTypeStringify(parseInt(item.item_type))

          crudAPI.dfsResourceShow(res, item.item_id).then(result => {
            item.item_type_name = result.name

            this.items.push(item)
          }, () => {})
        })
      },
      itemTypeStringify (itemTypeId) {
        let res = ''

        switch (itemTypeId) {
          case this.inventoryTypeID:
            res = 'inventories'
            break

          case this.serviceTypeID:
            res = 'services'
            break

          case this.caseManagerTypeID:
            res = 'users'
            break
        }

        return res
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Bookings.vue?5bf8ac30